import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IUserFilesState = { };

const designTypeReducer = (
  state: types.IUserFilesState = defaultState, 
  action: IAction | types.ISetUserFilesAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_USERFILES_INFO: {
      return {...state, userFiles: (action as types.ISetUserFilesAction).userFiles};
    }
    case actionTypes.ADD_SUCCESS: {
      return {...state, response: (action as types.IServerSuccessAction).response};
    }
    case actionTypes.SET_SEARCH_USERFILES: {
      return {...state, searchesUserFiles: (action as types.ISetSearchAction).searchesUserFiles};
    }
    case actionTypes.SET_COUNTER: {
      return {...state, counter: (action as types.ISetCounterAction).counter};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
